import fill from 'lodash/fill';

import { SelectedPlan } from '../typings/plans';

export function getOfferIds(selectedPlans: SelectedPlan[]): string[] {
  return selectedPlans.flatMap((selectedPlan) => {
    return fill(Array(selectedPlan.quantity), selectedPlan.offerId);
  });
}
